import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../../api';

// Async thunk for fetching weight tracker data
export const fetchWeightTrackerData = createAsyncThunk(
  'weightTracker/fetchWeightTrackerData',
  async (filters = {}) => {
    const response = await api.post(
      `${process.env.REACT_APP_API_BASE_URL}/customer/get-weight-tracker-graph-data`,
      filters
    );
    return response.data.data;
  }
);

// Async thunk for fetching previous week's average weights
export const fetchAverageWeightsData = createAsyncThunk(
  'weightTracker/fetchAverageWeightsData',
  async (filters = {}) => {
    const response = await api.post(
      `${process.env.REACT_APP_API_BASE_URL}/customer/previous-weeks-average-weights`,
      filters
    );
    return response.data.data;
  }
);

// Async thunk for deleting weight entry
export const deleteWeightEntry = createAsyncThunk(
  'weightTracker/deleteWeightEntry',
  async (id) => {
    const response = await api.delete(`${process.env.REACT_APP_API_BASE_URL}/customer/delete-weights/${id}`);
    return response.data; // Assume the API returns the updated data
  }
);


/** AWS **/
/** 
export const addWeight = createAsyncThunk(
  "weightTracker/addWeight",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/generate-presigned-url`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);**/


export const addWeight = createAsyncThunk(
  "weightTracker/addWeight",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/generate-presigned-url`,
        payload, // plain JSON object now
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);



export const removeNotUploadedImages = createAsyncThunk(
  "weightTracker/removeNotUploadedImages",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/customer/remove-failed-aws-images`,
        payload, // plain JSON object now
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);



const weightTrackerSlice = createSlice({
  name: 'weightTracker',
  initialState: {
    weights: [],
    currentWeekAverage: 0,
    loading: false,
    errorMessage: '',
    weightData: null,
    averageWeightsData: [], // to store previous weeks' average steps data
  },
  reducers: {
    clearMessage: (state, action) => {
      state.errorMessage = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWeightTrackerData.pending, (state) => {
        state.errorMessage = '';
      })
      .addCase(fetchWeightTrackerData.fulfilled, (state, action) => {
        state.weights = action.payload.weights;
        state.currentWeekAverage = action.payload.current_week_average;
        state.loading = false;
      })
      .addCase(fetchWeightTrackerData.rejected, (state, action) => {
        state.errorMessage = action.error.message;
      })
      .addCase(deleteWeightEntry.fulfilled, (state, action) => {
        // Remove the deleted entry from the state
        state.weights = state.weights.filter(weight => weight.id !== action.payload.id);
      })
      .addCase(addWeight.fulfilled, (state, action) => {
        state.loading = false;
        state.weightData = action.payload;
      })
      .addCase(addWeight.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(removeNotUploadedImages.fulfilled, (state, action) => {
        state.loading = false;
        state.weightData = action.payload;
      })
      .addCase(removeNotUploadedImages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAverageWeightsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAverageWeightsData.fulfilled, (state, action) => {
        state.averageWeightsData = action.payload; 
        state.loading = false;
      })
      .addCase(fetchAverageWeightsData.rejected, (state, action) => {
        state.errorMessage = action.error.message;
        state.loading = false;
      });
  },
});

export const { clearMessage } = weightTrackerSlice.actions;

export default weightTrackerSlice.reducer;
